











































import Vue from 'vue'
import Component from 'vue-class-component'
import Card from '@/components/Card.vue'
import Checkbox from '@/components/inputsV2/Checkbox.vue'
import { EAdminTaskStatus, ETrainingMilestoneStatus, IAdminTask, ITrainingMilestone, ITrainingMilestoneTemplate, IUser } from '@zunta/configurations'
import Icon from '@/components/Icon.vue'
import TrainingSettingsModal from './TrainingSettingsModal.vue'
import Accordion from '@/components/Accordion.vue'
import TrainingDetailsMilestone from './TrainingDetailsMilestone.vue'
import DateTimeLabel from '@/components/labels/DateTimeLabel.vue'
import { UserModule } from '@/store/modules/user.module'
import { getModule } from 'vuex-module-decorators'

const groupBy = require('lodash.groupby')
const sortBy = require('lodash.sortby')

@Component({
  components: {
    Card,
    Checkbox,
    Icon,
    TrainingSettingsModal,
    Accordion,
    TrainingDetailsMilestone,
    DateTimeLabel
  },
  props: {
    userId: {
      type: String,
      required: true
    }
  }
})
export default class TrainingDetails extends Vue {
  ETrainingMilestoneStatus: any = ETrainingMilestoneStatus;
  showUpdateTraining: boolean = false
  userModuleInstance: UserModule = getModule(UserModule, this.$store);

  async updateMileStone (milestoneToUpdate: { milestone: number, event: boolean, parentId: number }) {
    const milestoneStatus = milestoneToUpdate.event ? ETrainingMilestoneStatus.COMPLETE : ETrainingMilestoneStatus.TODO
    const item = this.groupedMilestones.find((item: any) => item.parent.id === milestoneToUpdate.parentId)
    const isAllComeplete = item.sub
      .filter((item: ITrainingMilestone) => item.id !== milestoneToUpdate.milestone)
      .every((item: ITrainingMilestone) => item.status === ETrainingMilestoneStatus.COMPLETE)
    const milestoneParentStatus = isAllComeplete && milestoneStatus === ETrainingMilestoneStatus.COMPLETE
      ? ETrainingMilestoneStatus.COMPLETE
      : ETrainingMilestoneStatus.TODO
    await Promise.all([
      this.userModuleInstance
        .changeTrainingMilestoneStatus({ milestone: milestoneToUpdate.milestone, status: milestoneStatus }),
      this.userModuleInstance
        .changeTrainingMilestoneStatus({ milestone: milestoneToUpdate.parentId, status: milestoneParentStatus })
    ])
    await this.userModuleInstance.fetchUserTrainingMilestones(this.$props.userId)
  }

  get tasks () {
    return this.$store.state.chain.adminTasks.filter((adminTask: IAdminTask) => adminTask.status === EAdminTaskStatus.TODO)
  }

  get milestones () {
    return this.$store.state.user.trainingMilestones.filter((milestone: ITrainingMilestone) => milestone.required) as ITrainingMilestone[]
  }
  get subMilestoneTemplates () {
    return this.milestones.map((milestone: ITrainingMilestone) => milestone.template)
  }

  get groupedMilestones () {
    const milestones = this.milestones
    const group: any[] = []
    const groupedByParent = groupBy(milestones, (milestone: ITrainingMilestone) => (
      (milestone.template as ITrainingMilestoneTemplate).parent || '0'
    ))
    const parents = groupedByParent['0']
    const groupedById = groupBy(milestones, (milestone: ITrainingMilestone) => (
      (milestone.template as ITrainingMilestoneTemplate).id
    ))
    Object.keys(groupedByParent).forEach((key) => {
      if (key === '0') return
      group.push({
        parent: groupedById[key][0],
        sub: sortBy(groupedByParent[key], (milestone: ITrainingMilestone) => (
          (milestone.template as ITrainingMilestoneTemplate).order
        ))
      })
    })
    parents.forEach((parent: ITrainingMilestone) => {
      if (!group.find((item) => item.parent.id === parent.id)) {
        group.push({
          parent,
          sub: []
        })
      }
    })
    return sortBy(group, (group: any) => group.parent.template.order)
  }
}
